module.exports = __webpack_public_path__ + "static/portada-video-30años1-14c212bcf543e5923c2a26bddcb08684.png";